module.exports = __webpack_public_path__ + "img/graves.fb73295f.jpeg";